// type
import { SecuritySafe, Key, ShieldTick, Profile2User } from 'iconsax-react';
import { AES, enc } from 'crypto-js';
import * as url from '../store/constant/Endpoints';

// icons
const icons = {
  administration: SecuritySafe,
  roles: Key,
  permissions: ShieldTick,
  users: Profile2User
};

let permissionUser = localStorage.getItem('data');

let decryptedData = null;
if (permissionUser) {
  try {
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(enc.Utf8);
  } catch (error) {
    localStorage.clear();
    window.location = '/';
    window.location.reload();
  }
}

const permissions = JSON.parse(decryptedData)?.permissions;
const allowedPermissions = permissions && permissions.length !== 0 ? permissions.map((permission) => permission?.permission) : [];

const permissionsAccessFunction = (brand) =>
  allowedPermissions && allowedPermissions.length !== 0 && allowedPermissions.some((permission) => permission?.includes(brand));

// ==============================|| MENU ITEMS - ADMINISTRATION ||============================== //
// Roles, Permissions and User Management used to be three separate flat groups
// (each contributing its own row(s) straight to the sidebar). They're all the
// same "who can do what" concern, so they're now one collapsible parent.

const administrationChildren = [
  permissionsAccessFunction('role') && allowedPermissions?.includes('get-role')
    ? { id: 'allroles', title: 'All Roles', type: 'item', url: '/roles/all-roles', icon: icons.roles, breadcrumbs: true }
    : null,
  permissionsAccessFunction('permission') && allowedPermissions?.includes('assign-permission')
    ? { id: 'assign', title: 'Assign Permissions', type: 'item', url: '/permissions/assign', icon: icons.permissions, breadcrumbs: true }
    : null,
  permissionsAccessFunction('user') && allowedPermissions?.includes('get-user')
    ? { id: 'users', title: 'All Users', type: 'item', url: '/user-management/users', icon: icons.users, breadcrumbs: true }
    : null,
  permissionsAccessFunction('user') && allowedPermissions?.includes('register-user')
    ? { id: 'register-users', title: 'Users', type: 'item', url: '/user-management/register-user', icon: icons.users, breadcrumbs: true }
    : null
].filter(Boolean);

const administration =
  administrationChildren.length !== 0
    ? {
        id: 'administration-group',
        type: 'group',
        children: [
          {
            id: 'administration',
            title: 'Administration',
            type: 'collapse',
            icon: icons.administration,
            children: administrationChildren
          }
        ]
      }
    : null;

export default administration;
